import type { ComponentProps } from "react";

import { Editor } from "~/components/editor/Editor";
import { DOCUMENT_SETTINGS_EDITOR_CONTENT_MIN_HEIGHT } from "~/shared/documents/document-settings-ui.constants";

type DocumentSettingsEditorProps = Omit<ComponentProps<typeof Editor>, "contentMinHeight">;

/** Document rich-text editor — shared 150px min-height for org settings and create modals. */
export const DocumentSettingsEditor = (props: DocumentSettingsEditorProps) => (
  <Editor {...props} contentMinHeight={DOCUMENT_SETTINGS_EDITOR_CONTENT_MIN_HEIGHT} />
);
